import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const PageList = List;
export const PageCreate = Create;
export const PageShow = Show;
export const PageEdit = Edit;
